import React, { useEffect, useState } from "react";
import "./CompleteStudentListHW.css";
import Table from "react-bootstrap/Table";
import StudentTableProps from "./Complete_table_props/CompleteSTablePropsHW";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../axios";
import moment from "moment";
import { IP } from "../../../../internalServer";
import ExportTablePDf from "../../../../Components/exportTablePDf";

const CompleteStudentListHW = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const [basicinfo, setBasicInfo] = useState({});
  const [studentinfo, setStudentInfo] = useState([]);
  const [searchvalue, setSearchValue] = useState("");
  const [noresponse, setNoResponse] = useState(false);
  const [loading, setLoading] = useState(false);

  const header = (para) => `${para[1]} ${para[0]} HW`;

  const timeDate = (para) => {
    const d = new Date(para);
    return `${d.getUTCDate()}/${d.getUTCMonth() + 1}/${d.getUTCFullYear()}`;
  };

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };

  useEffect(() => {
    const fetching = async () => {
      setLoading(true);
      setNoResponse(false);

      try {
        const res = await axios.get(
          `/api/v1/homework/studentHomework/getByHomeworkId/${state.homework_id}?name=${searchvalue}`
        );

        const data = res.data.data;

        if (!data || data.length === 0) {
          setStudentInfo([]);
          setNoResponse(true);
          return;
        }

        let helperArr = [];

        data.forEach((obj, idx) => {
          if (idx === 0) {
            setBasicInfo({
              header: header(obj.homework_id.tags),
              belowHeader: obj.homework_id.subject_id.name,
              timeDate: formatDate(obj.deadline),
              chapter: obj.homework_id.tags[0],
              homework_name: obj.homework_id.name,
            });
          }

          helperArr.push({
            profile_pic: obj.student_id.profile_picture
              ? IP +
                obj.student_id.profile_picture.substring(
                  obj.student_id.profile_picture.indexOf("/")
                )
              : "/images/table pic1.svg",
            Name: obj.student_id.name,
            School_Email: obj.student_id.roll_number,
            Class: `${obj.homework_id.standard_id.name}`,
            Division: obj.homework_id.section_id.name,
            Submited_Date: obj.submitted_on
              ? timeDate(obj.submitted_on)
              : "Not Submitted",
            Status: obj.status,
            HomeWork_id: obj.homework_id.id,
            Student_id: obj.student_id.id,
            avatar_profile: obj.student_id.avatar_profile,
            gender: obj.student_id.gender,
            Student_marks: obj.obtained_marks || "0",
            total_marks: obj.homework_id.total_marks,
            submitted_on: obj.submitted_on || "-",
            deadline: obj.deadline,
          });
        });

        setStudentInfo(helperArr);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetching();
  }, [searchvalue]);

  return (
    <>
      <div
        className="d-flex align-items-center headingMargin"
        style={{ marginBottom: "15px" }}
      >
        <div
          onClick={() => navigate("/publishedHomework")}
          className="d-flex flex-row align-items-center justify-content-center"
        >
          <img
            style={{ cursor: "pointer" }}
            src="/images/Back Arrow.svg"
            alt=""
          />
          <div className="d-flex flex-column gap-1">
            <span className="head_manual">Homework</span>
            <span className="fw-small text-muted" style={{ fontSize: "10px" }}>
              Dashboard / Homework / Completed / {basicinfo.homework_name}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-2 ms-1 d-flex align-items-center justify-content-between">
        <h1 className="published_tittle_heading ms-2">
          {basicinfo.homework_name}
        </h1>
        <ExportTablePDf studentinfo={studentinfo} basicinfo={basicinfo} />
      </div>

      <div
        className="h-100 p-2 d-flex flex-column rounded-2"
        style={{ backgroundColor: "white", width: "100%" }}
      >
        <div className="me-5 mt-3 d-flex align-items-center justify-content-between">
          <div className="mt-1 ms-1 gap-2 d-flex align-items-center">
            <span className="open_ststus_hw">Completed</span>
            <span className="greyText">{basicinfo.belowHeader}</span>
            <span className="greyText">| Deadline</span>
            <span className="DeadlineText">{basicinfo.timeDate}</span>
          </div>

          <div className="col-12 col-md-4 p-0">
            <input
              className="form-control mr-sm-2 m-0 name_search_box"
              type="search"
              placeholder="Search by Student name"
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <img
              className="name_search_icon"
              src="/images/search icon.svg"
              alt=""
            />
          </div>
        </div>

        <div
          className="mt-4 table_area col-8 col-md-11 orange-scrollBar"
          style={{
            maxHeight: "400px",
            overflow: "auto",
            paddingBottom: "10px",
          }}
        >
          <Table
            responsive
            className="student_profile_table"
            borderless
            style={{ textAlign: "center" }}
          >
            <thead style={{ position: "sticky", top: 0 }}>
              <tr>
                <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                  Name
                </th>
                <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                  Roll No
                </th>
                <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                  Class
                </th>
                <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                  Division
                </th>
                <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                  Date submitted
                </th>
                <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                  Marks
                </th>
                <th style={{ backgroundColor: "#e2e2e2", color: "white" }}>
                  Status
                </th>
              </tr>
            </thead>

            <tbody>
              {/* 🔵 Loading UI */}
              {loading && (
                <tr>
                  <td colSpan="7" style={{ padding: 20, textAlign: "center" }}>
                    <img src="/gif/LoaderDot.gif" height="40" alt="loading" />
                    <div className="mt-2 text-muted">Loading students...</div>
                  </td>
                </tr>
              )}

              {/* 🟠 No student found */}
              {!loading && noresponse && (
                <tr>
                  <td colSpan="7" style={{ padding: 20, textAlign: "center" }}>
                    <div className="mt-2 fw-bold">No student found</div>
                    <div className="text-muted" style={{ fontSize: 12 }}>
                      Try searching with a different name.
                    </div>
                  </td>
                </tr>
              )}

              {/* 🟢 Normal student rows */}
              {!loading && !noresponse && studentinfo.length > 0 && (
                <StudentTableProps studentinfo={studentinfo} />
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default CompleteStudentListHW;
